const items = (props) => {
  const { history, me, setPrintOpen, logout, showHome = true } = props;

  const goTo = (path) => {
    history.push(path);
  };

  const { role: userRole } = me || {};
  const canPlan = userRole === "admin" || userRole === "planner";

  const doLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return [
    {
      label: "Početna",
      icon: "home",
      condition: showHome,
      onClick: () => goTo("/"),
    },
    { label: "Moj Profil", icon: "person", onClick: () => goTo("/me") },
    {
      label: "Novi plan",
      condition: canPlan,
      icon: "create",
      onClick: () => goTo("/create"),
    },
    {
      label: "Randomize",
      condition: canPlan,
      icon: "shuffle",
      onClick: () => goTo("/randomize"),
    },
    { label: "Štampa", icon: "print", onClick: () => setPrintOpen(true) },
    { label: "Odjavi se", icon: "logout", onClick: () => doLogout() },
  ];
};

export default items;
